import React, { useEffect } from 'react';
import _ from 'lodash';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation } from 'react-fetching-library';
import { updateOrderAction } from '../../../../services/request';
import { updateOrder } from '../../../../services/redux-actions';
import { Box, Tabs, Tab, Button, Badge } from '@mui/material';
import Scrollbar from '../../../../components/Scrollbar';
import OrderTab from './tabs/OrderTab/OrderTab';
import ReservationDataForm from './tabs/ReservationDataTab/ReservationDataForm';
import ParticipantDetails from './tabs/ParticipanDetailsTab/ParticipantDetails';
import DocumentsAndNotifications from './tabs/DocumentAndNotificationsTab/DocumentsAndNotifications';
import SettlementTab from './tabs/SettlementTab/SettlementTab';
import ChangeHistory from './tabs/ChangeHistoryTab/ChangeHistory';
import Iconify from '../../../../components/Iconify';
import { ZSReservationDetails } from './tabs/ZSReservationTab/ZSReservationDetails';
import toast from 'react-hot-toast';

const tabInputs = {
  orderTab: ['identifier', 'participant_name', 'participant_street_address', 'participant_postal_code', 'participant_city', 'guardian_name', 'guardian_correspondence_email', 'guardian_street_address', 'guardian_postal_code', 'guardian_city'],
  settlementTab: ['contractor_name', 'contractor_street_address', 'contractor_postal_code', 'contractor_city', 'contractor_correspondence_email']
};

const validationSchema = Yup.object({
  identifier: Yup.string().required('To pole nie może być puste'),
  created_at: Yup.date().required('To pole nie może być puste'),
  period_from: Yup.date().required('To pole nie może być puste'),
  period_to: Yup.date().required('To pole nie może być puste')
});


export const ZSFullScreenView = ({ updateOrders, refFormik }) => {
  const dispatch = useDispatch();
  const { order } = useSelector(state => state.orderData);
  const { seasonYear } = useSelector(state => state.app);
  const { loading, mutate } = useMutation(updateOrderAction);
  const [currentTab, setCurrentTab] = React.useState(0);
  const [validationErros, setValidationErrors] = React.useState({ orderTab: false, settlementTab: false });

  const handleSubmit = async (orderId, values) => {
    const { error, payload } = await mutate(orderId, values);
    if (!error) {
      const clone = structuredClone(values);
      clone.paintball_participants_count = payload.paintball_participants_count;
      clone.activities = payload.activities;
      clone.final_payment_date = payload.final_payment_date;
      clone.advance_payment_date = payload.advance_payment_date;
      if (payload.educational_trip.length == 0) {
        clone.educational_trip = null;
      }
      formik.resetForm({
        values: clone
      });
      dispatch(updateOrder(payload));
      updateOrders(payload);
      toast.success('Zaktualizowano zamówienie');
    } else {
      // eslint-disable-next-line no-lonely-if
      if (_.isArray(payload)) {
        toast.error(payload[0]);
      } else {
        toast.error('Nie udało się zapisać zmian');
      }
    }
  };

  const formik = useFormik({
    initialValues: {
      // OrderTab
      identifier: _.isNil(order.identifier) ? '' : order.identifier,
      created_at: _.isNil(order.created_at) ? '' : order.created_at,
      resort: _.isNil(order.resort) ? '' : order.resort,
      period: _.isNil(order.period) ? '' : order.period,
      period_from: _.isNil(order.period_from) ? '' : order.period_from,
      period_to: _.isNil(order.period_to) ? '' : order.period_to,
      package: _.isNil(order.package) ? '' : order.package,
      agreement_signer_name: _.isNil(order.agreement_signer_name) ? '' : order.agreement_signer_name,
      agreement_signer_surname: _.isNil(order.agreement_signer_surname) ? '' : order.agreement_signer_surname,
      office_representative_name: _.isNil(order.office_representative_name) ? '' : order.office_representative_name,
      office_representative_surname: _.isNil(order.office_representative_surname) ? '' : order.office_representative_surname,
      office_representative_phone: _.isNil(order.office_representative_phone) ? '' : order.office_representative_phone,
      office_representative_additional_phone: _.isNil(order.office_representative_additional_phone) ? '' : order.office_representative_additional_phone,
      office_representative_correspondence_email: _.isNil(order.office_representative_correspondence_email) ? '' : order.office_representative_correspondence_email,
      paintball_participants_count: _.isNil(order.paintball_participants_count) ? '' : order.paintball_participants_count,
      optional_activity_count_1: _.isNil(order.optional_activity_count_1) ? null : order.optional_activity_count_1,
      optional_activity_count_2: _.isNil(order.optional_activity_count_2) ? null : order.optional_activity_count_2,
      optional_activity_count_3: _.isNil(order.optional_activity_count_3) ? null : order.optional_activity_count_3,
      // ReservationDataForm
      rodo_terms: order.rodo_terms,
      other_terms: order.other_terms,
      marketing_consents_email: order.marketing_consents_email,
      marketing_consents_sms: order.marketing_consents_sms,
      marketing_consents_phone: order.marketing_consents_phone,
      marketing_consents_survey: order.marketing_consents_survey,
      source_of_offer: _.isNil(order.source_of_offer) ? '' : order.source_of_offer,
      form_of_communication: _.isNil(order.form_of_communication) ? '' : order.form_of_communication,
      return_of_health_card: order.return_of_health_card,
      no_return_of_card: order.no_return_of_card,
      no_return_of_card_description: _.isNil(order.no_return_of_card_description) ? '' : order.no_return_of_card_description,
      return_agreement: order.return_agreement,
      // annex_return: order.annex_return,
      accommodated: order.accommodated,
      family_card_number: _.isNil(order.family_card_number) ? '' : order.family_card_number,
      provisions: _.isNil(order.provisions) ? '' : order.provisions,
      road_distance_to_school: _.isNil(order.road_distance_to_school) ? null : order.road_distance_to_school,
      without_photos: _.isNil(order.without_photos) ? '' : order.without_photos,
      // ZSReservationDetails
      activities: _.isNil(order.activities) ? [] : order.activities,
      educational_trip: _.isNil(order.educational_trip) ? '' : order.educational_trip.length > 0 ? order.educational_trip[0] : null,
      school_name: _.isNil(order.school_name) ? '' : order.school_name,
      school_province: _.isNil(order.school_province) ? '' : order.school_province,
      school_commune: _.isNil(order.school_commune) ? '' : order.school_commune,
      school_county: _.isNil(order.school_county) ? '' : order.school_county,
      school_street_address: _.isNil(order.school_street_address) ? '' : order.school_street_address,
      school_city: _.isNil(order.school_city) ? '' : order.school_city,
      school_postal_code: _.isNil(order.school_postal_code) ? '' : order.school_postal_code,
      school_nip: _.isNil(order.school_nip) ? '' : order.school_nip,
      use_contract_payer_data: _.isNil(order.use_contract_payer_data) ? false : order.use_contract_payer_data,
      contract_payer_name: _.isNil(order.contract_payer_name) ? '' : order.contract_payer_name,
      contract_payer_contact_person: _.isNil(order.contract_payer_contact_person) ? '' : order.contract_payer_contact_person,
      boys_count: _.isNil(order.boys_count) ? '' : order.boys_count,
      girls_count: _.isNil(order.girls_count) ? '' : order.girls_count,
      participants_age: _.isNil(order.participants_age) ? '' : order.participants_age,
      participants_age_json: _.isNil(order.participants_age_json) ? [] : order.participants_age_json,
      additional_participants_info: _.isNil(order.additional_participants_info) ? '' : order.additional_participants_info,
      additional_participants_class_info: _.isNil(order.additional_participants_class_info) ? '' : order.additional_participants_class_info,
      free_guardian_man_count: _.isNil(order.free_guardian_man_count) ? '' : order.free_guardian_man_count,
      free_guardian_woman_count: _.isNil(order.free_guardian_woman_count) ? '' : order.free_guardian_woman_count,
      paid_guardian_man_count: _.isNil(order.paid_guardian_man_count) ? '' : order.paid_guardian_man_count,
      paid_guardian_woman_count: _.isNil(order.paid_guardian_woman_count) ? '' : order.paid_guardian_woman_count,
      driver_on_resort: _.isNil(order.driver_on_resort) ? false : order.driver_on_resort,
      important_notes: _.isNil(order.important_notes) ? '' : order.important_notes,
      drivers_count: _.isNil(order.drivers_count) ? null : order.drivers_count,
      // DocumentsAndNotifications
      automatic_notifications: order.automatic_notifications,
      manual_notifications: order.manual_notifications,
      coordinator_teacher_mail: _.isNil(order.coordinator_teacher_mail) ? '' : order.coordinator_teacher_mail,
      accomodation_teacher_mail: _.isNil(order.accomodation_teacher_mail) ? '' : order.accomodation_teacher_mail,
      teacher_mail_p8: _.isNil(order.teacher_mail_p8) ? '' : order.teacher_mail_p8,
      trip_teacher_mail: _.isNil(order.trip_teacher_mail) ? '' : order.trip_teacher_mail,
      // SettlementTab
      contractor_name: _.isNil(order.contractor_name) ? '' : order.contractor_name,
      contractor_nip: _.isNil(order.contractor_nip) ? '' : order.contractor_nip,
      contractor_phone: _.isNil(order.contractor_phone) ? '' : order.contractor_phone,
      contractor_correspondence_email: _.isNil(order.contractor_correspondence_email) ? '' : order.contractor_correspondence_email,
      contractor_street_address: _.isNil(order.contractor_street_address) ? '' : order.contractor_street_address,
      contractor_postal_code: _.isNil(order.contractor_postal_code) ? '' : order.contractor_postal_code,
      contractor_city: _.isNil(order.contractor_city) ? '' : order.contractor_city,
      invoice: '',
      advance_payment_date: _.isNil(order.advance_payment_date) ? null : order.advance_payment_date,
      final_payment_date: _.isNil(order.final_payment_date) ? null : order.final_payment_date,
      manual_payment_dates: order.manual_payment_dates,
      is_invoice_issued: order.is_invoice_issued,
      is_invoice_paid: order.is_invoice_paid,
      accounting_notes: _.isNil(order.accounting_notes) ? '' : order.accounting_notes,
      automatic_advance_reminder_notifications: _.isNil(order.automatic_advance_reminder_notifications) ? true : order.automatic_advance_reminder_notifications,
      without_director: _.isNil(order.without_director) ? false : order.without_director,
      way_of_sending_contract: _.isNil(order.way_of_sending_contract) ? '' : order.way_of_sending_contract,
      fixed_calculations_values: _.isNil(order.fixed_calculations_values) ? true : order.fixed_calculations_values,
      fixed_gross_value_per_guardian: _.isNil(order.fixed_gross_value_per_guardian) ? '' : order.fixed_gross_value_per_guardian,
      fixed_gross_value_per_participant: _.isNil(order.fixed_gross_value_per_participant) ? '' : order.fixed_gross_value_per_participant,
      want_invoice: order.want_invoice,
      discounted_gross_value_per_participant: _.isNil(order.discounted_gross_value_per_participant) ? '' : order.discounted_gross_value_per_participant,
      zs_special_diet: _.isNil(order.zs_special_diet) ? false : order.zs_special_diet,
      zs_special_diet_info: _.isNil(order.zs_special_diet_info) ? '' : order.zs_special_diet_info,
      discounted_gross_value_per_participant_title: _.isNil(order.discounted_gross_value_per_participant_title) ? '' : order.discounted_gross_value_per_participant_title,
      positions: _.isNil(order.products) ? [] : order.products.map(p => ({ status: 'OLD', ...p })),
      zs_diets_json: _.isNil(order.zs_diets_json) ? [] : order.zs_diets_json,
      additionally_paid_activities_json: _.isNil(order.additionally_paid_activities_json) ? [] : order.additionally_paid_activities_json,
      has_children_with_disability: order.has_children_with_disability,
      children_with_disability: _.isNil(order.children_with_disability) ? [] : order.children_with_disability
    },
    validationSchema,
    validateOnChange: true,
    onSubmit: values => {
      if (_.filter(values.activities, v => v.label.toLowerCase().includes('paintball')).length > 0 && values.paintball_participants_count == 0 && seasonYear < 2026) {
        toast.error('Wybierając zajęcie paintballowe należy podać liczbę uczestników większą od 0');

        return;
      }
      if (_.filter(values.activities, v => v.label.toLowerCase().includes('paintball')).length == 0 && values.paintball_participants_count > 0) {
        toast.error('Podając liczbę uczestników gry paintballowej większą od 0, należy wybrać również zajęcie gry paintballowej');

        return;
      }
      if (_.isObject(values.period)) {
        values.period = values.period.value;
      }
      if (_.isObject(values.package)) {
        values.package = values.package.value;
      }
      if (typeof values.educational_trip === 'object' && values.educational_trip !== null && !Array.isArray(values.educational_trip)) {
        values.educational_trip = [values.educational_trip.value];
      } else if (!_.isArray(values.educational_trip)) {
        values.educational_trip = [values.educational_trip];
      }
      handleSubmit(order.id, values);
    }
  });

  useEffect(() => {
    let orderTabCount = 0;
    let settlementTabCount = 0;

    if (!_.isEmpty(formik.errors)) {
      const keys = Object.keys(formik.errors);

      for (const key of keys) {
        if (tabInputs.orderTab.includes(key)) {
          orderTabCount++;
        } else if (tabInputs.settlementTab.includes(key)) {
          settlementTabCount++;
        }
      }

      toast.error('Upewnij się czy wszystkie pola zostały poprawnie wypełnione');
    }

    if (orderTabCount > 0) {
      setValidationErrors(prev => ({ ...prev, orderTab: true }));
    } else {
      setValidationErrors(prev => ({ ...prev, orderTab: false }));
    }

    if (settlementTabCount > 0) {
      setValidationErrors(prev => ({ ...prev, settlementTab: true }));
    } else {
      setValidationErrors(prev => ({ ...prev, settlementTab: false }));
    }
  }, [formik.errors]);

  refFormik.current = formik;

  return (
    <>
      <Box sx={{ mb: 2 }}>
        <Tabs sx={{ ml: 1 }} value={currentTab} onChange={(e, value) => setCurrentTab(value)}>
          <Tab
            label="zamówienie"
            icon={<Badge color="error" variant="dot" invisible={!validationErros.orderTab}><Iconify icon={'icon-park-outline:transaction-order'} width={20} height={20} /></Badge>} />
          <Tab label="dane rezerwacji" icon={<Iconify icon={'ri:hotel-fill'} width={20} height={20} />} />
          <Tab label="szczegóły wyjazdu" icon={<Iconify icon={'ic:baseline-directions-bus'} width={20} height={20} />} />
          <Tab label="dokumenty i powiadomienia" icon={<Iconify icon={'mdi:file-document-multiple'} width={20} height={20} />} />
          <Tab
            label="rozliczenia"
            icon={<Badge color="error" variant="dot" invisible={!validationErros.settlementTab}><Iconify icon={'mdi:currency-usd'} width={20} height={20} /></Badge>} />
          <Tab label="historia zmian" icon={<Iconify icon={'mdi:clipboard-text-clock'} width={20} height={20} />} />
        </Tabs>
        <Box sx={{ mt: 2, mb: 2 } } display="flex" justifyContent="center" alignItems="center">
          <Button
            variant="contained"
            disabled={!formik.dirty || loading}
            onClick={formik.handleSubmit}
            sx={{ width: '50%' }}
          >
            Zapisz zmiany
          </Button>
        </Box>
      </Box>
      <Scrollbar>
        { currentTab === 0
          ? <OrderTab
            formik={formik}
          />
          : currentTab === 1
            ? <ReservationDataForm
              formik={formik}
            />
            : currentTab === 2
              ? <ZSReservationDetails
                order={order}
                formik={formik}
              />
              : currentTab === 3
                ? <DocumentsAndNotifications
                  updateOrders={updateOrders}
                  formik={formik}
                />
                : currentTab === 4
                  ? <SettlementTab
                    formik={formik}
                  />
                  : currentTab === 5
                    ? <ChangeHistory />
                    : null}
      </Scrollbar>
    </>
  );
};
